export class EventType {
    static REMINDER = 'reminder';
    static VISIT = 'visit';
    static TEST_DRIVE = 'test_drive';

}
